import { connect, ConnectedProps } from "react-redux";

import { ExperiencesSearchControl } from "./component";
import { IStoreState } from "../../../../reducers/types";
import {
  getLocation,
  getLocationCategoriesLoading,
  getLocationCategories,
  getHasLocationAutocompleteError,
  getFromDate,
  getUntilDate,
  getMergedCombinedGroups,
  getCombinedAutocompleteLoading,
  getHasCombinedAutocompleteError,
  getEntryTypesAll,
} from "../../reducer/index";
import {
  getTripDestinations,
  getTripDestinationsLoading,
} from "../../reducer";
import {
  setFromDate,
  setUntilDate,
  setLocation,
  setEntryType,
  fetchLocationCategories,
  fetchCombinedAutocomplete,
  clearCombinedAutocomplete,
} from "../../actions/actions";
import {
  fetchInitialExperiencesAvailability,
  resetFilterAndSort,
} from "../../../availability/actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  location: getLocation(state),
  locationCategories: getLocationCategories(state),
  locationCategoriesLoading: getLocationCategoriesLoading(state),
  hasLocationAutocompleteError: getHasLocationAutocompleteError(state),
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  tripDestinations: getTripDestinations(state),
  tripDestinationsLoading: getTripDestinationsLoading(state),
  combinedGroups: getMergedCombinedGroups(state),
  combinedLoading: getCombinedAutocompleteLoading(state),
  hasCombinedError: getHasCombinedAutocompleteError(state),
  entryTypesAll: getEntryTypesAll(state),
});

const mapDispatchToProps = {
  setFromDate,
  setUntilDate,
  setLocation,
  setEntryType,
  fetchInitialExperiencesAvailability,
  resetFilterAndSort,
  fetchLocationCategories,
  fetchCombinedAutocomplete,
  clearCombinedAutocomplete,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ExperiencesSearchControlConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedExperiencesSearchControl = connector(
  ExperiencesSearchControl
);
